import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, Clock, CreditCard, AlertTriangle, CalendarCheck, Ban } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Loader } from "@/components/Loader";

export default function AdminDashboard() {
  const { t } = useApp();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {}); }, []);
  if (!stats) return <Loader />;

  const cards = [
    { label: t("active_members"), value: stats.active, icon: Users, color: "#10B981", to: "/admin/members?status=active" },
    { label: t("pending_applications"), value: stats.pending, icon: Clock, color: "#F59E0B", to: "/admin/members?status=application_pending" },
    { label: t("awaiting_payment"), value: stats.awaiting_payment, icon: CreditCard, color: "#EAB308", to: "/admin/members?status=approved_payment_pending" },
    { label: t("expiring_soon"), value: stats.expiring_soon, icon: AlertTriangle, color: "#EF4444", to: "/admin/members?status=active" },
    { label: t("event_rsvps"), value: stats.total_rsvps, icon: CalendarCheck, color: "#D4AF37", to: "/admin/events" },
    { label: t("suspend"), value: stats.suspended, icon: Ban, color: "#A39E93", to: "/admin/members?status=suspended" },
  ];

  return (
    <div className="fade-up">
      <h1 className="font-serif-cu text-3xl mb-1">{t("dashboard")}</h1>
      <p className="eyebrow mb-8">Caught Up International</p>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((c) => (
          <button key={c.label} onClick={() => navigate(c.to)} data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`} className="cu-card p-5 text-left hover:-translate-y-0.5 transition-transform">
            <c.icon size={20} style={{ color: c.color }} />
            <div className="font-serif-cu text-4xl mt-4" style={{ color: c.color }}>{c.value}</div>
            <div className="eyebrow mt-2">{c.label}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
